import React from 'react';
import PropTypes from 'prop-types';
import { ClientAdminButtonComponent } from './ClientAdminButtonComponent';

export const AcceptButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="accept_button"
    aClass="update_status accept button"
    aData={{
      action: 'accept',
      status: 'plan',
      tileId,
    }}
    buttonText="Accept"
  />
);

AcceptButton.propTypes = {
  tileId: PropTypes.string.isRequired,
};

export const ArchiveButton = ({ tile, changeTileStatus }) => (
  <ClientAdminButtonComponent
    aClass="button update_status left"
    aData={{
      action: 'archive',
      status: 'archive',
      tileId: tile.id,
    }}
    buttonText="Archive"
    onClickAction={() => changeTileStatus(tile)}
  />
);

ArchiveButton.propTypes = {
  tile: PropTypes.object,
  changeTileStatus: PropTypes.func,
};

export const DirectDestroyButton = ({ tileId, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass="destroy pill right"
    aClass="delete_tile"
    aData={{
      action: 'delete',
      tileId,
    }}
    faIcon="fa-regular fa-trash-can"
    onClickAction={onClickAction}
  />
);

DirectDestroyButton.propTypes = {
  tileId: PropTypes.string.isRequired,
  onClickAction: PropTypes.func,
};

export const EditButton = ({ tileId, activeStatus, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass='edit_button right'
    aClass='edit'
    aData={{
      action: 'edit',
      status: activeStatus,
      tileId,
    }}
    onClickAction={onClickAction}
    faIcon='fa-regular fa-pencil'
    spanText='Edit'
  />
);

EditButton.propTypes = {
  activeStatus: PropTypes.string.isRequired,
  tileId: PropTypes.string.isRequired,
  onClickAction: PropTypes.func,
};

export const IgnoreButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="ignore_button"
    aClass="update_status ignore button outlined"
    aData={{
      action: 'ignore',
      status: 'ignored',
      tileId,
    }}
    buttonText="Ignore"
  />
);

IgnoreButton.propTypes = {
  tileId: PropTypes.string.isRequired,
};

export const IncompleteEditButton = ({
  tileId,
  activeStatus,
  onClickAction,
}) => (
  <ClientAdminButtonComponent
    liClass='incomplete_button'
    aClass='button left'
    aData={{
      action: 'edit',
      status: activeStatus,
      tileId,
    }}
    faIcon='fa-regular fa-pencil'
    spanText='Edit'
    onClickAction={onClickAction}
  />
);

IncompleteEditButton.propTypes = {
  onClickAction: PropTypes.func,
  activeStatus: PropTypes.string.isRequired,
  tileId: PropTypes.string.isRequired,
};

export const IncompleteDestroyButton = ({ tileId, onClickAction }) => (
  <ClientAdminButtonComponent
    liClass='destroy pill right incomplete'
    aClass='delete_tile'
    aData={{
      action: 'delete',
      tileId,
    }}
    faIcon='fa-solid fa-trash-can'
    onClickAction={onClickAction}
  />
);

IncompleteDestroyButton.propTypes = {
  tileId: PropTypes.string.isRequired,
  onClickAction: PropTypes.func,
};

export const UnarchiveButton = ({ tile, changeTileStatus }) => (
  <ClientAdminButtonComponent
    aClass="button update_status left"
    aData={{
      action: 'unarchive',
      status: 'active',
      tileId: tile.id,
    }}
    buttonText="Post Again"
    onClickAction={() => changeTileStatus(tile)}
  />
);

UnarchiveButton.propTypes = {
  changeTileStatus: PropTypes.func,
  tile: PropTypes.object,
  tileId: PropTypes.string.isRequired,
};

export const UndoIgnoreButton = ({ tileId }) => (
  <ClientAdminButtonComponent
    liClass="undo_ignore_button"
    aClass="update_status undo_ignore button outlined"
    aData={{
      action: 'unignore',
      status: 'user_submitted',
      tileId,
    }}
    buttonText="Undo Ignore"
  />
);

UndoIgnoreButton.propTypes = {
  tileId: PropTypes.string.isRequired,
};
